/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScoreMorseViewerAliases {
  ACTION_INACTIVATE_SCORE_MORSE = 'action-inactivate-score-morse',
  ACTION_NEW_SCORE_MORSE = 'action-new-score-morse',
  ACTION_REFERENCE_SCORE_MORSE = 'action-reference-score-morse',
  CHECKBOX_ENDOVENOUS_DEVICE_OPTION = 'checkbox-endovenous-device-option',
  CHECKBOX_FALL_HISTORY_OPTION = 'checkbox-fall-history-option',
  CHECKBOX_HAS_COMORBIDITY_OPTION = 'checkbox-has-comorbidity-option',
  CONTEXTUAL_BAR = 'contextual-bar',
  FIELD_AMBULATORY_AID = 'field-ambulatory-aid',
  FIELD_DS_PUNCTUATION = 'field-ds-punctuation',
  FIELD_ENDOVENOUS_DEVICE_OPTION = 'field-endovenous-device-option',
  FIELD_EVALUATION_DATE = 'field-evaluation-date',
  FIELD_FALL_HISTORY_OPTION = 'field-fall-history-option',
  FIELD_GAIT_CHARACTERISTIC = 'field-gait-characteristic',
  FIELD_HAS_COMORBIDITY_OPTION = 'field-has-comorbidity-option',
  FIELD_MENTAL_STATE = 'field-mental-state',
  FIELD_PROFESSIONAL = 'field-professional',
  FIELD_PUNCTUATION = 'field-punctuation',
  FORM_SCORE_MORSE_VIEWER = 'form-score-morse-viewer',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_EVATUALION_DATE = 'input-evatualion-date',
  INPUT_PROFESSIONAL = 'input-professional',
  LAYOUT_SCORE_MORSE_VIEWER = 'layout-score-morse-viewer',
  RADIO_GROUP_AMBULATORY_AID = 'radio-group-ambulatory-aid',
  RADIO_GROUP_GAIT_CHARACTERISTIC = 'radio-group-gait-characteristic',
  RADIO_GROUP_MENTAL_STATE = 'radio-group-mental-state',
  TEXT_DS_PUNCTUATION = 'text-ds-punctuation',
  TEXT_PUNCTUATION = 'text-punctuation',
}
export { ScoreMorseViewerAliases };
